(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!window.__rhPremiumHeaderInteractionsBound) {
    window.__rhPremiumHeaderInteractionsBound = true;

    const rhDesktopHeaderDetails = () => document.querySelectorAll(
      '.rh-header-wrapper .header__inline-menu details[open]'
    );

    const rhSyncMenuState = (details) => {
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    };

    const rhCloseMenu = (details) => {
      details.removeAttribute('open');
      rhSyncMenuState(details);
    };

    document.querySelectorAll(
      '.rh-header-wrapper .header__inline-menu details, .rh-header-wrapper header-drawer details'
    ).forEach((details) => {
      rhSyncMenuState(details);
      details.addEventListener('toggle', () => rhSyncMenuState(details));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const openDetails = Array.from(rhDesktopHeaderDetails());
      if (!openDetails.length) return;

      const activeDetails = openDetails.find((details) => details.contains(document.activeElement))
        || openDetails[openDetails.length - 1];
      openDetails.forEach(rhCloseMenu);
      activeDetails.querySelector(':scope > summary')?.focus();
      event.preventDefault();
    });

    document.addEventListener('pointerdown', (event) => {
      const openDetails = Array.from(rhDesktopHeaderDetails());
      if (!openDetails.length) return;
      if (openDetails.some((details) => details.contains(event.target))) return;
      openDetails.forEach(rhCloseMenu);
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-accessory-motion2-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('#motion2-page');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const rt = (key, vars = {}) => (root.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  let localizedKnowledge = {};
  try {
    const parsedKnowledge = JSON.parse(root.querySelector('[data-rh-localized-knowledge]')?.textContent || '{}');
    if (parsedKnowledge && typeof parsedKnowledge === 'object' && !Array.isArray(parsedKnowledge)) localizedKnowledge = parsedKnowledge;
  } catch {}
  const rhCopy = (key, values = {}) => {
    let value = root.getAttribute('data-rh-rt-' + key) || '';
    return value.replace(/%\{([a-z_]+)\}/g, (token, name) => String(values[name] ?? ''));
  };
  const familyLabel = rhCopy('family');
  const controllerName = root.id === 'motion2-page' ? 'DJI RC Motion 2' : root.id === 'motion3-page' ? 'DJI RC Motion 3' : 'DJI RC-N1';
  const formatGoggles = names => new Intl.ListFormat(document.documentElement.lang || 'en', {type: 'disjunction'}).format(names);
  const compatibilityDetail = (item) => {
    const entries = localizedKnowledge.compatibility || [];
    const faqs = localizedKnowledge.faqs || [];
    const detail = i => entries[i]?.details?.value || '';
    if (root.id === 'motion2-page') {
      if (item.status === 'yes') {
        const goggles = {"model-1": ["DJI Goggles 2", "DJI Goggles Integra", "DJI FPV Goggles V2"], "model-2": ["DJI Goggles 2", "DJI Goggles Integra"], "model-3": ["DJI Goggles 2", "DJI Goggles Integra"], "model-4": ["DJI Goggles 2", "DJI Goggles Integra"], "model-5": ["DJI Goggles 2", "DJI Goggles Integra"], "model-6": ["DJI Goggles 2", "DJI Goggles Integra"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? rhCopy('copy_pairing_no', {controller: controllerName}) : rhCopy('copy_ask_models');
    }
    if (root.id === 'motion3-page') {
      if (item.status === 'yes') {
        const goggles = {"model-0": ["DJI Goggles 3", "Goggles N3"], "model-2": ["DJI Goggles 3", "Goggles N3"], "model-4": ["DJI Goggles 3"], "model-5": ["DJI Goggles 3"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? detail(3) : rhCopy('copy_ask_models');
    }
    if (item.key === 'mini4pro') return rhCopy('copy_rcn1_mini4');
    return item.status === 'check' ? rhCopy('copy_ask_exact_model') : rhCopy('copy_rcn1_yes');
  };
  data.compatibility = data.compatibility.map(item => {
    const label = item.label.replace(/ family$/, ' ' + familyLabel);
    let title = item.title;
    if (item.status === 'no') title = item.key === 'mini4pro'
      ? rhCopy('title_rcn1_mini4')
      : rhCopy('title_no', {model: label});
    else if (item.status === 'check') title = root.id === 'rcn1-page'
      ? rhCopy('title_rcn1_check')
      : rhCopy('title_check');
    else title = item.title.replace(/ family$/, ' ' + familyLabel);
    if (item.key === 'other') return {...item, label: rhCopy('other_model'), title, copy: compatibilityDetail(item)};
    return {...item, label, title, copy: compatibilityDetail(item)};
  });
  const form = root.querySelector('#ra-product-form');
  const quantity = form.querySelector('[name="quantity"]');
  const variants = data.variants;
  const currency = data.currency || 'USD';
  let rhCurrencyFormatter;
  const format = (cents) => {
    if (!rhCurrencyFormatter) rhCurrencyFormatter = new Intl.NumberFormat('en-US', {style:'currency', currency});
    return rhCurrencyFormatter.format(cents / 100);
  };
  const us = cents => 'US$' + (cents / 100).toFixed(2);
  const q = sel => root.querySelector(sel);
  const selectedInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
  let variant = variants.find(v => String(v.id) === selectedInput.value) || variants[0];

  function updateOffer(changeUrl = false) {
    const totalUnits = Math.max(1, Math.min(99, Math.floor(Number(quantity.value) || 1)));
    quantity.value = String(totalUnits);
    const subtotal = variant.price * totalUnits;
    const shipping = subtotal >= 9900 ? 0 : 2888;
    q('[data-price]').textContent = format(variant.price);
    q('[data-sticky-price]').textContent = format(subtotal);
    q('[data-sticky-condition]').textContent = document.getElementById("motion2-page").getAttribute("data-rh-condition");
    q('[data-stock]').textContent = variant.available ? document.getElementById("motion2-page").getAttribute("data-rh-available") : document.getElementById("motion2-page").getAttribute("data-rh-unavailable");
    const comparison = q('[data-compare-group]');
    comparison.hidden = !(variant.compare_at_price > variant.price);
    if (!comparison.hidden) {
      q('[data-compare]').textContent = format(variant.compare_at_price);
      q('[data-discount]').textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + document.getElementById("motion2-page").getAttribute("data-rh-discount");
    }
    if (currency === 'USD' && root.dataset.country !== 'UG') {
      q('[data-order-total]').textContent = us(subtotal + shipping);
      q('[data-item-cost]').textContent = us(subtotal);
      q('[data-shipping]').textContent = shipping ? us(shipping) : document.getElementById("motion2-page").getAttribute("data-rh-free");
      q('[data-sticky-shipping]').textContent = shipping ? document.getElementById("motion2-page").getAttribute("data-rh-shipping") : document.getElementById("motion2-page").getAttribute("data-rh-shipping-free");
      q('[data-single-total]').textContent = us(variant.price + (variant.price >= 9900 ? 0 : 2888));
    } else {
      const delivery = window.RHControllerShipping?.fromPage(root, subtotal);
      const singleDelivery = window.RHControllerShipping?.fromPage(root, variant.price);
      const display = value => window.RHControllerShipping.format(root, value, delivery?.approximate);
      q('[data-order-total]').textContent = delivery ? display(delivery.total) : root.getAttribute('data-rh-confirmed');
      q('[data-item-cost]').textContent = format(subtotal);
      q('[data-shipping]').textContent = delivery ? display(delivery.shipping) : root.getAttribute('data-rh-calculated');
      q('[data-sticky-shipping]').textContent = root.getAttribute('data-rh-shipping-checkout');
      q('[data-single-total]').textContent = singleDelivery ? window.RHControllerShipping.format(root, singleDelivery.total, singleDelivery.approximate) : root.getAttribute('data-rh-confirmed');
      const freeFact = q('.ra-delivery-facts > span:first-child');
      if (freeFact) { freeFact.hidden = delivery?.threshold === null; freeFact.style.display = freeFact.hidden ? 'none' : ''; }
      const baseNote = q('[data-base-shipping-note]');
      if (baseNote && delivery?.threshold === null) baseNote.textContent = display(delivery.shipping) + ' · ' + root.getAttribute('data-rh-shipping-checkout');
    }
    root.querySelectorAll('[data-add],[data-sticky-add]').forEach(button => {
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? document.getElementById("motion2-page").getAttribute("data-rh-add") : document.getElementById("motion2-page").getAttribute("data-rh-unavailable");
    });
    q('[data-qty="-1"]').disabled = totalUnits === 1;
    q('[data-qty="1"]').disabled = totalUnits === 99;
    if (changeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
  }
  form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', () => {
    variant = variants.find(v => String(v.id) === input.value) || variant;
    updateOffer(true);
  }));
  quantity.addEventListener('change', () => updateOffer());
  quantity.addEventListener('input', () => { if (quantity.value !== '') updateOffer(); });
  root.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
    quantity.value = String((Number(quantity.value) || 1) + Number(button.dataset.qty));
    updateOffer();
  }));
  updateOffer();

  const heroImage = q('[data-hero-image]');
  root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
    const index = Number(button.dataset.photo);
    const item = data.images[index];
    const sized = width => {const url = new URL(item.url);url.searchParams.set('width', width);return url.href;};
    heroImage.srcset = [480,640,960,1200,1600].map(width => `${sized(width)} ${width}w`).join(',');
    heroImage.src = sized(1200);
    q('.ra-photo-wrap').dataset.primary = String(index === 0);
    heroImage.dataset.full = item.url;
    heroImage.alt = item.alt || 'DJI RC Motion 2 product photograph';
    q('[data-gallery-count]').textContent = String(index + 1).padStart(2,'0') + ' / ' + String(data.images.length).padStart(2,'0');
    root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const photoDialog = q('[data-photo-dialog]');
  q('[data-zoom]').addEventListener('click', () => {
    photoDialog.querySelector('img').src = heroImage.dataset.full || data.images[0].url;
    photoDialog.showModal();
  });
  const reportImage = q('[data-report-image]');
  const reportTabs = [...root.querySelectorAll('[data-report-tab]')];
  function selectReport(button) {
    reportTabs.forEach(tab => {
      tab.setAttribute('aria-selected', String(tab === button));
      tab.tabIndex = tab === button ? 0 : -1;
    });
    reportImage.src = button.dataset.reportSrc;
    reportImage.alt = button.dataset.reportCaption;
    q('.ra-report-caption [data-report-caption]').textContent = button.dataset.reportCaption;
    q('[data-report-open]').setAttribute('aria-label', rhCopy('aria_enlarge', {caption: button.dataset.reportCaption}));
    q('#ra-report-panel').setAttribute('aria-labelledby', button.id);
  }
  if (reportImage) reportTabs.forEach((button, index) => {
    button.addEventListener('click', () => selectReport(button));
    button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % reportTabs.length;
      if (event.key === 'ArrowLeft') next = (index + reportTabs.length - 1) % reportTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = reportTabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      reportTabs[next].focus();
      selectReport(reportTabs[next]);
    });
  });
  if (reportImage) q('[data-report-open]').addEventListener('click', () => {
    const enlarged = q('[data-report-enlarged]');
    enlarged.src = reportImage.src;
    enlarged.alt = reportImage.alt;
    q('[data-report-dialog]').showModal();
  });
  const videoDialog = q('[data-video-dialog]');
  const video = videoDialog.querySelector('video');
  root.querySelectorAll('[data-video-open]').forEach(button => button.addEventListener('click', () => {
    videoDialog.showModal();
    video.src = button.dataset.videoSrc;
     video.poster = button.dataset.videoPoster || '';
     video.setAttribute('aria-label', button.dataset.videoLabel);
     videoDialog.setAttribute('aria-label', button.dataset.videoLabel);
    video.play().catch(() => { /* Native controls remain available if playback needs another gesture. */ });
  }));
  videoDialog.addEventListener('close', () => {
    video.pause();
    video.removeAttribute('src');
    video.load();
  });
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {if (event.target === dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  });

  const select = q('#ra-drone');
  const result = q('.ra-fit-result');
  select.addEventListener('change', () => {
    const match = data.compatibility.find(item => item.key === select.value);
    if (!match) return;
    result.dataset.fitStatus = match.status;
    q('[data-fit-label]').textContent = match.status === 'yes' ? rhCopy('status_yes') : match.status === 'no' ? rhCopy('status_no') : rhCopy('status_check');
    q('[data-fit-title]').textContent = match.title;
    q('[data-fit-copy]').textContent = match.copy;
    const source = q('[data-fit-source]');
    source.href = match.source;
    source.firstChild.textContent = match.status === 'check' ? rhCopy('ask_team').replace(/\s*↗\s*$/, '') + ' ' : rhCopy('dji_reference') + ' ';
  });
  const sticky = q('.ra-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);}, {threshold:0}).observe(form);
  }
  if (root.dataset.preview === 'true') {
    root.querySelectorAll('[data-preview-checkout]').forEach(button => button.addEventListener('click', () => {
      updateOffer();
      q('[data-demo-summary]').textContent = `Shopify accelerated checkout preview · ${quantity.value} × DJI RC Motion 2 · Pristine Pre-owned · ${format(variant.price * Number(quantity.value))}. The published page uses Shopify’s native payment button.`;
      q('[data-demo-dialog]').showModal();
    }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      updateOffer();
      q('[data-demo-summary]').textContent = `${quantity.value} × DJI RC Motion 2 · Pristine Pre-owned · ${format(variant.price * Number(quantity.value))}`;
      q('[data-demo-dialog]').showModal();
    });
  }
})();

(function () {
  'use strict';
  const FREE_AT=9900,STANDARD_SHIPPING=2888;
  const SUPPORTED_MODELS=new Set(["model-1","model-2","model-3","model-4","model-5","model-6"]);
  function matchesModel(extra,model){return SUPPORTED_MODELS.has(model)&&Array.isArray(extra.models)&&extra.models.includes(model);}
  function selectedExtras(extras,selections,model){
    const seen=new Set();
    return selections.map(({handle,variantId})=>{
      if(seen.has(handle))throw Error(rtCart('extra_duplicate'));seen.add(handle);
      const extra=extras.find(e=>e.handle===handle);
      if(!extra||!matchesModel(extra,model))throw Error(rtCart('extra_mismatch'));
      if(!variantId)throw Error(rtCart('extra_choose_option',{item:extra.title}));
      const v=extra.variants.find(v=>String(v.id)===String(variantId));
      if(!v?.available||!extra.allowedVariantIds?.includes(String(v.id)))throw Error(rtCart('extra_unavailable_set',{item:extra.title}));
      return {id:v.id,price:v.price,title:extra.title,handle:extra.handle};
    });
  }
  function estimate({cartTotal,mainPrice,mainQuantity,extrasTotal,currency,cartCurrency}){
    for(const n of [cartTotal,mainPrice,mainQuantity,extrasTotal])if(!Number.isSafeInteger(n)||n<0)throw Error(rtCart('invalid_amount'));
    if(mainQuantity<1)throw Error(rtCart('invalid_quantity'));
    const itemsSubtotal=cartTotal+mainPrice*mainQuantity+extrasTotal;
    const supportedCurrency=typeof currency==='string'&&currency.length>0&&cartCurrency===currency;
    const supportedUSD=supportedCurrency&&currency==='USD';
    const shipping=supportedUSD?(itemsSubtotal>=FREE_AT?0:STANDARD_SHIPPING):null;
    return {itemsSubtotal,supportedCurrency,supportedUSD,remaining:supportedUSD?Math.max(0,FREE_AT-itemsSubtotal):null,shipping,total:supportedUSD?itemsSubtotal+shipping:null};
  }
  function detailText(extra,variantId){
    const kind=extra?.detailType;
    if(!['drone','goggles','goggles3'].includes(kind))return '';
    const variant=extra.variants?.find(v=>String(v.id)===String(variantId));
    const title=String(variant?.title||'');
    const grade=kind==='goggles3'?'Flawless':title.match(/\b(Pristine Pre-owned|Flawless|Brand New)\b/i)?.[1]||'';
    const packageText=kind==='drone'?'Drone only · No battery or controller included':'Headset only · No motion controller included';
    return [grade,packageText].filter(Boolean).join(' · ');
  }
  function addCardDetail(card,extra){
    const detail=detailText(extra,card.dataset.id);if(!detail)return;
    let note=card.querySelector('[data-rh-motion-extra-detail]');
    if(!note){const nativeDescription=card.querySelector('.upsell__desc');if(!nativeDescription)return;
      note=card.ownerDocument.createElement('p');note.className='upsell__desc ra-motion-extra-detail';note.dataset.rhMotionExtraDetail='';nativeDescription.insertAdjacentElement('afterend',note);
    }
    if(note.textContent!==detail)note.textContent=detail;
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={matchesModel,selectedExtras,estimate,detailText,addCardDetail};
  if(typeof document==='undefined')return;
  const page=document.querySelector('#motion2-page'),json=page?.querySelector('[data-product-json]');
  if(!json)return;
  let product;try{product=JSON.parse(json.textContent);}catch{return;}
  const rtCart = (key, vars = {}) => (page.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  const find=s=>page.querySelector(s),dialog=find('[data-extras-dialog]'),open=find('[data-extra-open]');
  const model=find('[data-extra-model]'),list=find('[data-extra-list]'),empty=find('[data-extra-empty]'),status=find('[data-extra-status]');
  const nativeForm=find('[data-extra-native-form]'),form=find('#ra-extra-set-form'),submit=find('[data-extra-submit]');
  const mainIdInput=find('[data-extra-main-id]'),mainQuantityInput=find('[data-extra-main-quantity]'),compatibility=find('#ra-drone');
  if(!dialog||!open||!model||!list||!nativeForm||!form||!submit||!mainIdInput||!mainQuantityInput)return;
  const preview=page.dataset.preview==='true',currency=product.currency,extras=product.extras||[];
  const groups=[...list.querySelectorAll('[data-extras-group]')];
  const errorWrapper=nativeForm.querySelector('.product-form__error-message-wrapper');
  let cart=product.cart,cartLoading=false,pending=false,blocked=false,blockMessage='',previewMessage='',uncertaintyTimer;
  let cartUpdateEvent=null,cartEventsBound=false;
  let rhExtrasCurrencyFormatter;
  const money=n=>{
    if(currency==='USD')return 'US$'+(n/100).toFixed(2);
    if(!rhExtrasCurrencyFormatter)rhExtrasCurrencyFormatter=new Intl.NumberFormat('en-US',{style:'currency',currency});
    return rhExtrasCurrencyFormatter.format(n/100);
  };
  const put=(s,v)=>{const e=find(s);if(e)e.textContent=v;};
  const validCart=()=>cart&&Number.isSafeInteger(cart.total_price)&&cart.total_price>=0&&typeof cart.currency==='string';
  function currentMain(){const selected=find('#ra-product-form input[name=id]:checked');return {variant:product.variants.find(v=>String(v.id)===String(selected?.value)),quantity:Number(find('#ra-product-form input[name=quantity]')?.value)};}
  function selectedCards(){return [...list.querySelectorAll("product-info-upsell[data-selected='true']")].map(e=>({handle:e.dataset.handle,variantId:e.dataset.id}));}
  function clearSelections(){for(const card of list.querySelectorAll('product-info-upsell')){card.dataset.selected='false';const toggle=card.querySelector('.upsell-toggle-btn');if(toggle?.hasAttribute('aria-pressed'))toggle.setAttribute('aria-pressed','false');}previewMessage='';}
  function showModel(){
    let shown=0;
    for(const group of groups){group.hidden=!SUPPORTED_MODELS.has(model.value)||group.dataset.modelKey!==model.value;if(!group.hidden)shown+=[...group.querySelectorAll('product-info-upsell')].filter(card=>!card.hidden).length;}
    for(const card of list.querySelectorAll('product-info-upsell')){const extra=extras.find(x=>x.handle===card.dataset.handle);const approved=!!extra?.allowedVariantIds?.includes(String(card.dataset.id))&&extra.models.includes(model.value);card.hidden=!approved;if(!approved&&card.dataset.selected==='true')card.dataset.selected='false';if(approved)addCardDetail(card,extra);}
    shown=[...list.querySelectorAll('product-info-upsell')].filter(card=>!card.hidden&&!card.closest('[data-extras-group]').hidden).length;
    empty.hidden=shown>0;
    empty.textContent=!model.value?document.getElementById("motion2-page").getAttribute("data-rh-choose-drone"):!SUPPORTED_MODELS.has(model.value)?rtCart('model_unconfirmed',{model:'Motion 2'}):rtCart('empty_extras');
  }
  function changeModel(value,notify){model.value=value;clearSelections();showModel();render();if(notify&&compatibility&&compatibility.value!==value&&[...compatibility.options].some(o=>o.value===value)){compatibility.value=value;compatibility.dispatchEvent(new Event('change',{bubbles:true}));}}
  function fail(message){blocked=true;pending=false;clearTimeout(uncertaintyTimer);blockMessage=message;render();}
  function render(){
    const {variant:main,quantity}=currentMain();
    const mainValid=String(main?.id)==='46457473368241'&&!!main?.available&&Number.isSafeInteger(quantity)&&quantity>0;
    mainIdInput.value=mainValid?main.id:'';mainQuantityInput.value=mainValid?quantity:'';
    let chosen=[],selectionError='';try{chosen=selectedExtras(extras,selectedCards(),model.value);}catch(e){selectionError=e.message;}
    const currencyMatches=validCart()&&cart.currency===currency&&page.dataset.currency===currency;
    const canEstimate=mainValid&&currencyMatches&&!selectionError;
    const result=canEstimate?estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,e)=>s+e.price,0),currency,cartCurrency:cart.currency}):null;
    const marketDelivery = result ? window.RHControllerShipping?.fromPage(page, result.itemsSubtotal) : null;
    const useMarket = currency !== 'USD' || page.dataset.country === 'UG';
    const delivery = useMarket ? marketDelivery : result?.supportedUSD ? {...result, threshold:FREE_AT, approximate:false} : null;
    const deliveryMoney = value => window.RHControllerShipping.format(page, value, delivery?.approximate);
    const goal = delivery || window.RHControllerShipping?.fromPage(page, 0);
    const thresholdAmount = find('[data-rh-threshold-amount]');
    if (thresholdAmount && goal?.threshold != null) thresholdAmount.firstChild.nodeValue = window.RHControllerShipping.format(page, goal.threshold, goal.approximate);
    const freeBenefit = find('[data-rh-free-benefit]');
    if (freeBenefit) freeBenefit.hidden = !!goal && goal.threshold === null;
    const freeProgress = find('.ra-extra-threshold');
    if (freeProgress) freeProgress.style.display = goal?.threshold === null ? 'none' : '';
    for(const card of list.querySelectorAll('product-info-upsell')){const toggle=card.querySelector('.upsell-toggle-btn'),extra=extras.find(x=>x.handle===card.dataset.handle);if(toggle&&extra){toggle.setAttribute('aria-pressed',String(card.dataset.selected==='true'));toggle.setAttribute('aria-label',card.dataset.selected==='true'?rtCart('remove_extra',{item:extra.title}):rtCart('select_extra',{item:extra.title}));}}
    put('[data-extra-current-cart]',validCart()?money(cart.total_price):document.getElementById("motion2-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-main-label]',mainValid?'Motion 2 × '+quantity:'Motion 2 '+page.getAttribute('data-rh-unavailable'));
    put('[data-extra-main-amount]',mainValid?money(main.price*quantity):document.getElementById("motion2-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-subtotal]',result?money(result.itemsSubtotal):document.getElementById("motion2-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-shipping]',delivery ? (delivery.shipping===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.shipping)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-total]',delivery ? deliveryMoney(delivery.total) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-remaining]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?rtCart('threshold_reached'):rtCart('extra_remaining',{amount:deliveryMoney(delivery.remaining)})) : page.getAttribute('data-rh-shipping-checkout'));
    const progress=find('[data-extra-progress]');progress.hidden=delivery?.threshold==null;if(delivery?.threshold!=null){progress.max=delivery.threshold;progress.value=Math.min(result.itemsSubtotal,delivery.threshold);}else progress.removeAttribute('value');
    put('[data-extra-gap]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.remaining)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-gap-label]',delivery?.remaining!=null ? (delivery.remaining===0?rtCart('standard_fee_selection'):page.getAttribute('data-rh-shipping-goal')) : page.getAttribute('data-rh-shipping-checkout'));
    const context=chosen.length?rtCart('planned_set'):rtCart('with_model',{model:'Motion 2'});put('[data-extra-context]',cart?.item_count?rtCart('existing_cart_context',{context}):context);
    put('[data-extra-shipping-promise]',delivery?.threshold===null ? deliveryMoney(delivery.shipping)+' · '+page.getAttribute('data-rh-shipping-checkout') : result?.supportedUSD?(result.remaining===0?rtCart('free_shipping_reached'):page.getAttribute('data-rh-shipping-policy')):rtCart('base_policy'));
    const nativeReady=preview||(typeof customElements!=='undefined'&&!!customElements.get('product-form')&&cartEventsBound);
    submit.disabled=pending||blocked||cartLoading||!nativeReady||!canEstimate||!result?.supportedCurrency||!chosen.length;
    list.inert=pending;
    status.textContent=blocked?blockMessage:cartLoading?rtCart('cart_updating'):pending?rtCart('cart_adding'):previewMessage||selectionError||(!currencyMatches?rtCart('currency_unavailable'):!mainValid?rtCart('need_controller_quantity'):!chosen.length?rtCart('nothing_extra'):!nativeReady?rtCart('cart_loading'):'');
    find('[data-extra-cart-link]').href=product.routes.cart;
  }
  compatibility?.addEventListener('change',()=>{if(model.value!==compatibility.value)changeModel(compatibility.value,false);});
  model.addEventListener('change',()=>changeModel(model.value,true));
  page.addEventListener('change',e=>{if(e.target.matches('#ra-product-form input[name=id]'))render();});
  page.addEventListener('input',e=>{if(e.target.matches('#ra-product-form input[name=quantity]'))render();});
  page.addEventListener('click',e=>{if(e.target instanceof Element&&e.target.closest('#ra-product-form [data-qty]'))queueMicrotask(render);});
  dialog.addEventListener('close',()=>{if(!pending){clearSelections();render();}});
  new MutationObserver(()=>{showModel();render();}).observe(list,{subtree:true,childList:true,attributes:true,attributeFilter:['data-selected','data-id']});
  if(preview)list.addEventListener('click',e=>{const toggle=e.target.closest('.upsell-toggle-btn'),card=toggle?.closest('product-info-upsell');if(!card)return;e.preventDefault();card.dataset.selected=card.dataset.selected==='true'?'false':'true';toggle.setAttribute('aria-pressed',card.dataset.selected);});
  open.addEventListener('click',async()=>{
    if(!dialog.open)dialog.showModal();
    if(preview||blocked){render();return;}
    cartLoading=true;render();
    try{const r=await fetch(product.routes.cart.replace(/\/$/,'')+'.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('Cart read failed');const fresh=await r.json();if(!Number.isSafeInteger(fresh.total_price)||fresh.total_price<0||typeof fresh.currency!=='string')throw Error('Invalid cart');cart=fresh;}
    catch{cart=null;fail(rtCart('cart_read_error'));}
    finally{cartLoading=false;render();}
  });
  dialog.addEventListener('submit',e=>{
    if(e.target!==form)return;
    const {variant:main,quantity}=currentMain();let chosen=[],offer=null;
    try{chosen=selectedExtras(extras,selectedCards(),model.value);if(main?.available&&Number.isSafeInteger(quantity)&&quantity>0&&validCart())offer=estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,x)=>s+x.price,0),currency,cartCurrency:cart.currency});}catch{chosen=[];}
    const valid=!blocked&&!pending&&!cartLoading&&String(main?.id)==='46457473368241'&&offer?.supportedCurrency&&page.dataset.currency===currency&&chosen.length>0;
    if(!valid||preview){e.preventDefault();e.stopImmediatePropagation();if(preview&&valid)previewMessage='Preview only: Motion 2 × '+quantity+' + '+chosen.length+' selected extra'+(chosen.length>1?'s':'')+'. Items '+money(offer.itemsSubtotal)+ (offer.supportedUSD?'; standard shipping '+money(offer.shipping)+'; estimated total '+money(offer.total):'; shipping and final total calculated at checkout')+'. No store cart changes.';render();return;}
    if(typeof subscribe!=='function'||!cartUpdateEvent||!customElements.get('product-form')){e.preventDefault();e.stopImmediatePropagation();fail(rtCart('cart_form_unavailable'));return;}
    pending=true;uncertaintyTimer=setTimeout(()=>{if(pending)fail(rtCart('cart_uncertain'));},30000);render();
  },true);
  function bindNativeEvents(){
    if(preview||cartEventsBound||typeof subscribe!=='function'||typeof PUB_SUB_EVENTS==='undefined'||!PUB_SUB_EVENTS.cartUpdate)return;
    cartUpdateEvent=PUB_SUB_EVENTS.cartUpdate;
    subscribe(cartUpdateEvent,event=>{if(!pending||event?.source!=='product-form'||String(event.productVariantId)!==mainIdInput.id)return;pending=false;clearTimeout(uncertaintyTimer);dialog.close();window.location.assign(product.routes.cart);});
    cartEventsBound=true;
  }
  bindNativeEvents();
  if(errorWrapper)new MutationObserver(()=>{if(pending&&!errorWrapper.hidden&&errorWrapper.textContent.trim())fail(rtCart('cart_confirm_error'));}).observe(errorWrapper,{subtree:true,attributes:true,childList:true,characterData:true});
  if(!preview&&typeof customElements!=='undefined'){customElements.whenDefined('product-form').then(()=>{bindNativeEvents();render();});window.addEventListener('load',()=>{bindNativeEvents();render();},{once:true});}
  if(compatibility?.value)model.value=compatibility.value;
  showModel();render();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-accessory-motion3-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('#motion3-page');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const rt = (key, vars = {}) => (root.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  let localizedKnowledge = {};
  try {
    const parsedKnowledge = JSON.parse(root.querySelector('[data-rh-localized-knowledge]')?.textContent || '{}');
    if (parsedKnowledge && typeof parsedKnowledge === 'object' && !Array.isArray(parsedKnowledge)) localizedKnowledge = parsedKnowledge;
  } catch {}
  const rhCopy = (key, values = {}) => {
    let value = root.getAttribute('data-rh-rt-' + key) || '';
    return value.replace(/%\{([a-z_]+)\}/g, (token, name) => String(values[name] ?? ''));
  };
  const familyLabel = rhCopy('family');
  const controllerName = root.id === 'motion2-page' ? 'DJI RC Motion 2' : root.id === 'motion3-page' ? 'DJI RC Motion 3' : 'DJI RC-N1';
  const formatGoggles = names => new Intl.ListFormat(document.documentElement.lang || 'en', {type: 'disjunction'}).format(names);
  const compatibilityDetail = (item) => {
    const entries = localizedKnowledge.compatibility || [];
    const faqs = localizedKnowledge.faqs || [];
    const detail = i => entries[i]?.details?.value || '';
    if (root.id === 'motion2-page') {
      if (item.status === 'yes') {
        const goggles = {"model-1": ["DJI Goggles 2", "DJI Goggles Integra", "DJI FPV Goggles V2"], "model-2": ["DJI Goggles 2", "DJI Goggles Integra"], "model-3": ["DJI Goggles 2", "DJI Goggles Integra"], "model-4": ["DJI Goggles 2", "DJI Goggles Integra"], "model-5": ["DJI Goggles 2", "DJI Goggles Integra"], "model-6": ["DJI Goggles 2", "DJI Goggles Integra"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? rhCopy('copy_pairing_no', {controller: controllerName}) : rhCopy('copy_ask_models');
    }
    if (root.id === 'motion3-page') {
      if (item.status === 'yes') {
        const goggles = {"model-0": ["DJI Goggles 3", "Goggles N3"], "model-2": ["DJI Goggles 3", "Goggles N3"], "model-4": ["DJI Goggles 3"], "model-5": ["DJI Goggles 3"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? detail(3) : rhCopy('copy_ask_models');
    }
    if (item.key === 'mini4pro') return rhCopy('copy_rcn1_mini4');
    return item.status === 'check' ? rhCopy('copy_ask_exact_model') : rhCopy('copy_rcn1_yes');
  };
  data.compatibility = data.compatibility.map(item => {
    const label = item.label.replace(/ family$/, ' ' + familyLabel);
    let title = item.title;
    if (item.status === 'no') title = item.key === 'mini4pro'
      ? rhCopy('title_rcn1_mini4')
      : rhCopy('title_no', {model: label});
    else if (item.status === 'check') title = root.id === 'rcn1-page'
      ? rhCopy('title_rcn1_check')
      : rhCopy('title_check');
    else title = item.title.replace(/ family$/, ' ' + familyLabel);
    if (item.key === 'other') return {...item, label: rhCopy('other_model'), title, copy: compatibilityDetail(item)};
    return {...item, label, title, copy: compatibilityDetail(item)};
  });
  const form = root.querySelector('#ra-product-form');
  const quantity = form.querySelector('[name="quantity"]');
  const variants = data.variants;
  const currency = data.currency || 'USD';
  let rhCurrencyFormatter;
  const format = (cents) => {
    if (!rhCurrencyFormatter) rhCurrencyFormatter = new Intl.NumberFormat('en-US', {style:'currency', currency});
    return rhCurrencyFormatter.format(cents / 100);
  };
  const us = cents => 'US$' + (cents / 100).toFixed(2);
  const q = sel => root.querySelector(sel);
  const selectedInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
  let variant = variants.find(v => String(v.id) === selectedInput.value) || variants[0];

  function updateOffer(changeUrl = false) {
    const totalUnits = Math.max(1, Math.min(99, Math.floor(Number(quantity.value) || 1)));
    quantity.value = String(totalUnits);
    const subtotal = variant.price * totalUnits;
    const shipping = subtotal >= 9900 ? 0 : 2888;
    q('[data-price]').textContent = format(variant.price);
    q('[data-sticky-price]').textContent = format(subtotal);
    q('[data-sticky-condition]').textContent = document.getElementById("motion3-page").getAttribute("data-rh-condition");
    q('[data-stock]').textContent = variant.available ? document.getElementById("motion3-page").getAttribute("data-rh-available") : document.getElementById("motion3-page").getAttribute("data-rh-unavailable");
    const comparison = q('[data-compare-group]');
    comparison.hidden = !(variant.compare_at_price > variant.price);
    if (!comparison.hidden) {
      q('[data-compare]').textContent = format(variant.compare_at_price);
      q('[data-discount]').textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + document.getElementById("motion3-page").getAttribute("data-rh-discount");
    }
    if (currency === 'USD' && root.dataset.country !== 'UG') {
      q('[data-order-total]').textContent = us(subtotal + shipping);
      q('[data-item-cost]').textContent = us(subtotal);
      q('[data-shipping]').textContent = shipping ? us(shipping) : document.getElementById("motion3-page").getAttribute("data-rh-free");
      q('[data-sticky-shipping]').textContent = shipping ? document.getElementById("motion3-page").getAttribute("data-rh-shipping") : document.getElementById("motion3-page").getAttribute("data-rh-shipping-free");
      q('[data-single-total]').textContent = us(variant.price + (variant.price >= 9900 ? 0 : 2888));
    } else {
      const delivery = window.RHControllerShipping?.fromPage(root, subtotal);
      const singleDelivery = window.RHControllerShipping?.fromPage(root, variant.price);
      const display = value => window.RHControllerShipping.format(root, value, delivery?.approximate);
      q('[data-order-total]').textContent = delivery ? display(delivery.total) : root.getAttribute('data-rh-confirmed');
      q('[data-item-cost]').textContent = format(subtotal);
      q('[data-shipping]').textContent = delivery ? display(delivery.shipping) : root.getAttribute('data-rh-calculated');
      q('[data-sticky-shipping]').textContent = root.getAttribute('data-rh-shipping-checkout');
      q('[data-single-total]').textContent = singleDelivery ? window.RHControllerShipping.format(root, singleDelivery.total, singleDelivery.approximate) : root.getAttribute('data-rh-confirmed');
      const freeFact = q('.ra-delivery-facts > span:first-child');
      if (freeFact) { freeFact.hidden = delivery?.threshold === null; freeFact.style.display = freeFact.hidden ? 'none' : ''; }
      const baseNote = q('[data-base-shipping-note]');
      if (baseNote && delivery?.threshold === null) baseNote.textContent = display(delivery.shipping) + ' · ' + root.getAttribute('data-rh-shipping-checkout');
    }
    root.querySelectorAll('[data-add],[data-sticky-add]').forEach(button => {
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? document.getElementById("motion3-page").getAttribute("data-rh-add") : document.getElementById("motion3-page").getAttribute("data-rh-unavailable");
    });
    q('[data-qty="-1"]').disabled = totalUnits === 1;
    q('[data-qty="1"]').disabled = totalUnits === 99;
    if (changeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
  }
  form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', () => {
    variant = variants.find(v => String(v.id) === input.value) || variant;
    updateOffer(true);
  }));
  quantity.addEventListener('change', () => updateOffer());
  quantity.addEventListener('input', () => { if (quantity.value !== '') updateOffer(); });
  root.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
    quantity.value = String((Number(quantity.value) || 1) + Number(button.dataset.qty));
    updateOffer();
  }));
  updateOffer();

  const heroImage = q('[data-hero-image]');
  root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
    const index = Number(button.dataset.photo);
    const item = data.images[index];
    const sized = width => {const url = new URL(item.url);url.searchParams.set('width', width);return url.href;};
    heroImage.srcset = [480,640,960,1200,1600].map(width => `${sized(width)} ${width}w`).join(',');
    heroImage.src = sized(1200);
    q('.ra-photo-wrap').dataset.primary = String(index === 0);
    heroImage.dataset.full = item.url;
    heroImage.alt = item.alt || 'DJI RC Motion 3 product photograph';
    q('[data-gallery-count]').textContent = String(index + 1).padStart(2,'0') + ' / ' + String(data.images.length).padStart(2,'0');
    root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const photoDialog = q('[data-photo-dialog]');
  q('[data-zoom]').addEventListener('click', () => {
    photoDialog.querySelector('img').src = heroImage.dataset.full || data.images[0].url;
    photoDialog.showModal();
  });
  const reportImage = q('[data-report-image]');
  const reportTabs = [...root.querySelectorAll('[data-report-tab]')];
  function selectReport(button) {
    reportTabs.forEach(tab => {
      tab.setAttribute('aria-selected', String(tab === button));
      tab.tabIndex = tab === button ? 0 : -1;
    });
    reportImage.src = button.dataset.reportSrc;
    reportImage.alt = button.dataset.reportCaption;
    q('.ra-report-caption [data-report-caption]').textContent = button.dataset.reportCaption;
    q('[data-report-open]').setAttribute('aria-label', rhCopy('aria_enlarge', {caption: button.dataset.reportCaption}));
    q('#ra-report-panel').setAttribute('aria-labelledby', button.id);
  }
  if (reportImage) reportTabs.forEach((button, index) => {
    button.addEventListener('click', () => selectReport(button));
    button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % reportTabs.length;
      if (event.key === 'ArrowLeft') next = (index + reportTabs.length - 1) % reportTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = reportTabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      reportTabs[next].focus();
      selectReport(reportTabs[next]);
    });
  });
  if (reportImage) q('[data-report-open]').addEventListener('click', () => {
    const enlarged = q('[data-report-enlarged]');
    enlarged.src = reportImage.src;
    enlarged.alt = reportImage.alt;
    q('[data-report-dialog]').showModal();
  });
  const videoDialog = q('[data-video-dialog]');
  const video = videoDialog.querySelector('video');
  root.querySelectorAll('[data-video-open]').forEach(button => button.addEventListener('click', () => {
    videoDialog.showModal();
    video.src = button.dataset.videoSrc;
     video.poster = button.dataset.videoPoster || '';
     video.setAttribute('aria-label', button.dataset.videoLabel);
     videoDialog.setAttribute('aria-label', button.dataset.videoLabel);
    video.play().catch(() => { /* Native controls remain available if playback needs another gesture. */ });
  }));
  videoDialog.addEventListener('close', () => {
    video.pause();
    video.removeAttribute('src');
    video.load();
  });
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {if (event.target === dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  });

  const select = q('#ra-drone');
  const result = q('.ra-fit-result');
  select.addEventListener('change', () => {
    const match = data.compatibility.find(item => item.key === select.value);
    if (!match) return;
    result.dataset.fitStatus = match.status;
    q('[data-fit-label]').textContent = match.status === 'yes' ? rhCopy('status_yes') : match.status === 'no' ? rhCopy('status_no') : rhCopy('status_check');
    q('[data-fit-title]').textContent = match.title;
    q('[data-fit-copy]').textContent = match.copy;
    const source = q('[data-fit-source]');
    source.href = match.source;
    source.firstChild.textContent = match.status === 'check' ? rhCopy('ask_team').replace(/\s*↗\s*$/, '') + ' ' : rhCopy('dji_reference') + ' ';
  });
  const sticky = q('.ra-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);}, {threshold:0}).observe(form);
  }
  if (root.dataset.preview === 'true') {
    root.querySelectorAll('[data-preview-checkout]').forEach(button => button.addEventListener('click', () => {
      updateOffer();
      q('[data-demo-summary]').textContent = `Shopify accelerated checkout preview · ${quantity.value} × DJI RC Motion 3 · Pristine Pre-owned · ${format(variant.price * Number(quantity.value))}. The published page uses Shopify’s native payment button.`;
      q('[data-demo-dialog]').showModal();
    }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      updateOffer();
      q('[data-demo-summary]').textContent = `${quantity.value} × DJI RC Motion 3 · Pristine Pre-owned · ${format(variant.price * Number(quantity.value))}`;
      q('[data-demo-dialog]').showModal();
    });
  }
})();

(function () {
  'use strict';
  const FREE_AT=9900,STANDARD_SHIPPING=2888;
  const SUPPORTED_MODELS=new Set(["model-0","model-2","model-4","model-5"]);
  function matchesModel(extra,model){return SUPPORTED_MODELS.has(model)&&Array.isArray(extra.models)&&extra.models.includes(model);}
  function selectedExtras(extras,selections,model){
    const seen=new Set();
    return selections.map(({handle,variantId})=>{
      if(seen.has(handle))throw Error(rtCart('extra_duplicate'));seen.add(handle);
      const extra=extras.find(e=>e.handle===handle);
      if(!extra||!matchesModel(extra,model))throw Error(rtCart('extra_mismatch'));
      if(!variantId)throw Error(rtCart('extra_choose_option',{item:extra.title}));
      const v=extra.variants.find(v=>String(v.id)===String(variantId));
      if(!v?.available||!extra.allowedVariantIds?.includes(String(v.id)))throw Error(rtCart('extra_unavailable_set',{item:extra.title}));
      return {id:v.id,price:v.price,title:extra.title,handle:extra.handle};
    });
  }
  function estimate({cartTotal,mainPrice,mainQuantity,extrasTotal,currency,cartCurrency}){
    for(const n of [cartTotal,mainPrice,mainQuantity,extrasTotal])if(!Number.isSafeInteger(n)||n<0)throw Error(rtCart('invalid_amount'));
    if(mainQuantity<1)throw Error(rtCart('invalid_quantity'));
    const itemsSubtotal=cartTotal+mainPrice*mainQuantity+extrasTotal;
    const supportedCurrency=typeof currency==='string'&&currency.length>0&&cartCurrency===currency;
    const supportedUSD=supportedCurrency&&currency==='USD';
    const shipping=supportedUSD?(itemsSubtotal>=FREE_AT?0:STANDARD_SHIPPING):null;
    return {itemsSubtotal,supportedCurrency,supportedUSD,remaining:supportedUSD?Math.max(0,FREE_AT-itemsSubtotal):null,shipping,total:supportedUSD?itemsSubtotal+shipping:null};
  }
  function detailText(extra,variantId){
    const kind=extra?.detailType;
    if(!['drone','goggles','goggles3'].includes(kind))return '';
    const variant=extra.variants?.find(v=>String(v.id)===String(variantId));
    const title=String(variant?.title||'');
    const grade=kind==='goggles3'?'Flawless':title.match(/\b(Pristine Pre-owned|Flawless|Brand New)\b/i)?.[1]||'';
    const packageText=kind==='drone'?'Drone only · No battery or controller included':'Headset only · No motion controller included';
    return [grade,packageText].filter(Boolean).join(' · ');
  }
  function addCardDetail(card,extra){
    const detail=detailText(extra,card.dataset.id);if(!detail)return;
    let note=card.querySelector('[data-rh-motion-extra-detail]');
    if(!note){const nativeDescription=card.querySelector('.upsell__desc');if(!nativeDescription)return;
      note=card.ownerDocument.createElement('p');note.className='upsell__desc ra-motion-extra-detail';note.dataset.rhMotionExtraDetail='';nativeDescription.insertAdjacentElement('afterend',note);
    }
    if(note.textContent!==detail)note.textContent=detail;
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={matchesModel,selectedExtras,estimate,detailText,addCardDetail};
  if(typeof document==='undefined')return;
  const page=document.querySelector('#motion3-page'),json=page?.querySelector('[data-product-json]');
  if(!json)return;
  let product;try{product=JSON.parse(json.textContent);}catch{return;}
  const rtCart = (key, vars = {}) => (page.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  const find=s=>page.querySelector(s),dialog=find('[data-extras-dialog]'),open=find('[data-extra-open]');
  const model=find('[data-extra-model]'),list=find('[data-extra-list]'),empty=find('[data-extra-empty]'),status=find('[data-extra-status]');
  const nativeForm=find('[data-extra-native-form]'),form=find('#ra-extra-set-form'),submit=find('[data-extra-submit]');
  const mainIdInput=find('[data-extra-main-id]'),mainQuantityInput=find('[data-extra-main-quantity]'),compatibility=find('#ra-drone');
  if(!dialog||!open||!model||!list||!nativeForm||!form||!submit||!mainIdInput||!mainQuantityInput)return;
  const preview=page.dataset.preview==='true',currency=product.currency,extras=product.extras||[];
  const groups=[...list.querySelectorAll('[data-extras-group]')];
  const errorWrapper=nativeForm.querySelector('.product-form__error-message-wrapper');
  let cart=product.cart,cartLoading=false,pending=false,blocked=false,blockMessage='',previewMessage='',uncertaintyTimer;
  let cartUpdateEvent=null,cartEventsBound=false;
  let rhExtrasCurrencyFormatter;
  const money=n=>{
    if(currency==='USD')return 'US$'+(n/100).toFixed(2);
    if(!rhExtrasCurrencyFormatter)rhExtrasCurrencyFormatter=new Intl.NumberFormat('en-US',{style:'currency',currency});
    return rhExtrasCurrencyFormatter.format(n/100);
  };
  const put=(s,v)=>{const e=find(s);if(e)e.textContent=v;};
  const validCart=()=>cart&&Number.isSafeInteger(cart.total_price)&&cart.total_price>=0&&typeof cart.currency==='string';
  function currentMain(){const selected=find('#ra-product-form input[name=id]:checked');return {variant:product.variants.find(v=>String(v.id)===String(selected?.value)),quantity:Number(find('#ra-product-form input[name=quantity]')?.value)};}
  function selectedCards(){return [...list.querySelectorAll("product-info-upsell[data-selected='true']")].map(e=>({handle:e.dataset.handle,variantId:e.dataset.id}));}
  function clearSelections(){for(const card of list.querySelectorAll('product-info-upsell')){card.dataset.selected='false';const toggle=card.querySelector('.upsell-toggle-btn');if(toggle?.hasAttribute('aria-pressed'))toggle.setAttribute('aria-pressed','false');}previewMessage='';}
  function showModel(){
    let shown=0;
    for(const group of groups){group.hidden=!SUPPORTED_MODELS.has(model.value)||group.dataset.modelKey!==model.value;if(!group.hidden)shown+=[...group.querySelectorAll('product-info-upsell')].filter(card=>!card.hidden).length;}
    for(const card of list.querySelectorAll('product-info-upsell')){const extra=extras.find(x=>x.handle===card.dataset.handle);const approved=!!extra?.allowedVariantIds?.includes(String(card.dataset.id))&&extra.models.includes(model.value);card.hidden=!approved;if(!approved&&card.dataset.selected==='true')card.dataset.selected='false';if(approved)addCardDetail(card,extra);}
    shown=[...list.querySelectorAll('product-info-upsell')].filter(card=>!card.hidden&&!card.closest('[data-extras-group]').hidden).length;
    empty.hidden=shown>0;
    empty.textContent=!model.value?document.getElementById("motion3-page").getAttribute("data-rh-choose-drone"):!SUPPORTED_MODELS.has(model.value)?rtCart('model_unconfirmed',{model:'Motion 3'}):rtCart('empty_extras');
  }
  function changeModel(value,notify){model.value=value;clearSelections();showModel();render();if(notify&&compatibility&&compatibility.value!==value&&[...compatibility.options].some(o=>o.value===value)){compatibility.value=value;compatibility.dispatchEvent(new Event('change',{bubbles:true}));}}
  function fail(message){blocked=true;pending=false;clearTimeout(uncertaintyTimer);blockMessage=message;render();}
  function render(){
    const {variant:main,quantity}=currentMain();
    const mainValid=String(main?.id)==='46457438503089'&&!!main?.available&&Number.isSafeInteger(quantity)&&quantity>0;
    mainIdInput.value=mainValid?main.id:'';mainQuantityInput.value=mainValid?quantity:'';
    let chosen=[],selectionError='';try{chosen=selectedExtras(extras,selectedCards(),model.value);}catch(e){selectionError=e.message;}
    const currencyMatches=validCart()&&cart.currency===currency&&page.dataset.currency===currency;
    const canEstimate=mainValid&&currencyMatches&&!selectionError;
    const result=canEstimate?estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,e)=>s+e.price,0),currency,cartCurrency:cart.currency}):null;
    const marketDelivery = result ? window.RHControllerShipping?.fromPage(page, result.itemsSubtotal) : null;
    const useMarket = currency !== 'USD' || page.dataset.country === 'UG';
    const delivery = useMarket ? marketDelivery : result?.supportedUSD ? {...result, threshold:FREE_AT, approximate:false} : null;
    const deliveryMoney = value => window.RHControllerShipping.format(page, value, delivery?.approximate);
    const goal = delivery || window.RHControllerShipping?.fromPage(page, 0);
    const thresholdAmount = find('[data-rh-threshold-amount]');
    if (thresholdAmount && goal?.threshold != null) thresholdAmount.firstChild.nodeValue = window.RHControllerShipping.format(page, goal.threshold, goal.approximate);
    const freeBenefit = find('[data-rh-free-benefit]');
    if (freeBenefit) freeBenefit.hidden = !!goal && goal.threshold === null;
    const freeProgress = find('.ra-extra-threshold');
    if (freeProgress) freeProgress.style.display = goal?.threshold === null ? 'none' : '';
    for(const card of list.querySelectorAll('product-info-upsell')){const toggle=card.querySelector('.upsell-toggle-btn'),extra=extras.find(x=>x.handle===card.dataset.handle);if(toggle&&extra){toggle.setAttribute('aria-pressed',String(card.dataset.selected==='true'));toggle.setAttribute('aria-label',card.dataset.selected==='true'?rtCart('remove_extra',{item:extra.title}):rtCart('select_extra',{item:extra.title}));}}
    put('[data-extra-current-cart]',validCart()?money(cart.total_price):document.getElementById("motion3-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-main-label]',mainValid?'Motion 3 × '+quantity:'Motion 3 '+page.getAttribute('data-rh-unavailable'));
    put('[data-extra-main-amount]',mainValid?money(main.price*quantity):document.getElementById("motion3-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-subtotal]',result?money(result.itemsSubtotal):document.getElementById("motion3-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-shipping]',delivery ? (delivery.shipping===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.shipping)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-total]',delivery ? deliveryMoney(delivery.total) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-remaining]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?rtCart('threshold_reached'):rtCart('extra_remaining',{amount:deliveryMoney(delivery.remaining)})) : page.getAttribute('data-rh-shipping-checkout'));
    const progress=find('[data-extra-progress]');progress.hidden=delivery?.threshold==null;if(delivery?.threshold!=null){progress.max=delivery.threshold;progress.value=Math.min(result.itemsSubtotal,delivery.threshold);}else progress.removeAttribute('value');
    put('[data-extra-gap]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.remaining)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-gap-label]',delivery?.remaining!=null ? (delivery.remaining===0?rtCart('standard_fee_selection'):page.getAttribute('data-rh-shipping-goal')) : page.getAttribute('data-rh-shipping-checkout'));
    const context=chosen.length?rtCart('planned_set'):rtCart('with_model',{model:'Motion 3'});put('[data-extra-context]',cart?.item_count?rtCart('existing_cart_context',{context}):context);
    put('[data-extra-shipping-promise]',delivery?.threshold===null ? deliveryMoney(delivery.shipping)+' · '+page.getAttribute('data-rh-shipping-checkout') : result?.supportedUSD?(result.remaining===0?rtCart('free_shipping_reached'):page.getAttribute('data-rh-shipping-policy')):rtCart('base_policy'));
    const nativeReady=preview||(typeof customElements!=='undefined'&&!!customElements.get('product-form')&&cartEventsBound);
    submit.disabled=pending||blocked||cartLoading||!nativeReady||!canEstimate||!result?.supportedCurrency||!chosen.length;
    list.inert=pending;
    status.textContent=blocked?blockMessage:cartLoading?rtCart('cart_updating'):pending?rtCart('cart_adding'):previewMessage||selectionError||(!currencyMatches?rtCart('currency_unavailable'):!mainValid?rtCart('need_controller_quantity'):!chosen.length?rtCart('nothing_extra'):!nativeReady?rtCart('cart_loading'):'');
    find('[data-extra-cart-link]').href=product.routes.cart;
  }
  compatibility?.addEventListener('change',()=>{if(model.value!==compatibility.value)changeModel(compatibility.value,false);});
  model.addEventListener('change',()=>changeModel(model.value,true));
  page.addEventListener('change',e=>{if(e.target.matches('#ra-product-form input[name=id]'))render();});
  page.addEventListener('input',e=>{if(e.target.matches('#ra-product-form input[name=quantity]'))render();});
  page.addEventListener('click',e=>{if(e.target instanceof Element&&e.target.closest('#ra-product-form [data-qty]'))queueMicrotask(render);});
  dialog.addEventListener('close',()=>{if(!pending){clearSelections();render();}});
  new MutationObserver(()=>{showModel();render();}).observe(list,{subtree:true,childList:true,attributes:true,attributeFilter:['data-selected','data-id']});
  if(preview)list.addEventListener('click',e=>{const toggle=e.target.closest('.upsell-toggle-btn'),card=toggle?.closest('product-info-upsell');if(!card)return;e.preventDefault();card.dataset.selected=card.dataset.selected==='true'?'false':'true';toggle.setAttribute('aria-pressed',card.dataset.selected);});
  open.addEventListener('click',async()=>{
    if(!dialog.open)dialog.showModal();
    if(preview||blocked){render();return;}
    cartLoading=true;render();
    try{const r=await fetch(product.routes.cart.replace(/\/$/,'')+'.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('Cart read failed');const fresh=await r.json();if(!Number.isSafeInteger(fresh.total_price)||fresh.total_price<0||typeof fresh.currency!=='string')throw Error('Invalid cart');cart=fresh;}
    catch{cart=null;fail(rtCart('cart_read_error'));}
    finally{cartLoading=false;render();}
  });
  dialog.addEventListener('submit',e=>{
    if(e.target!==form)return;
    const {variant:main,quantity}=currentMain();let chosen=[],offer=null;
    try{chosen=selectedExtras(extras,selectedCards(),model.value);if(main?.available&&Number.isSafeInteger(quantity)&&quantity>0&&validCart())offer=estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,x)=>s+x.price,0),currency,cartCurrency:cart.currency});}catch{chosen=[];}
    const valid=!blocked&&!pending&&!cartLoading&&String(main?.id)==='46457438503089'&&offer?.supportedCurrency&&page.dataset.currency===currency&&chosen.length>0;
    if(!valid||preview){e.preventDefault();e.stopImmediatePropagation();if(preview&&valid)previewMessage='Preview only: Motion 3 × '+quantity+' + '+chosen.length+' selected extra'+(chosen.length>1?'s':'')+'. Items '+money(offer.itemsSubtotal)+ (offer.supportedUSD?'; standard shipping '+money(offer.shipping)+'; estimated total '+money(offer.total):'; shipping and final total calculated at checkout')+'. No store cart changes.';render();return;}
    if(typeof subscribe!=='function'||!cartUpdateEvent||!customElements.get('product-form')){e.preventDefault();e.stopImmediatePropagation();fail(rtCart('cart_form_unavailable'));return;}
    pending=true;uncertaintyTimer=setTimeout(()=>{if(pending)fail(rtCart('cart_uncertain'));},30000);render();
  },true);
  function bindNativeEvents(){
    if(preview||cartEventsBound||typeof subscribe!=='function'||typeof PUB_SUB_EVENTS==='undefined'||!PUB_SUB_EVENTS.cartUpdate)return;
    cartUpdateEvent=PUB_SUB_EVENTS.cartUpdate;
    subscribe(cartUpdateEvent,event=>{if(!pending||event?.source!=='product-form'||String(event.productVariantId)!==mainIdInput.id)return;pending=false;clearTimeout(uncertaintyTimer);dialog.close();window.location.assign(product.routes.cart);});
    cartEventsBound=true;
  }
  bindNativeEvents();
  if(errorWrapper)new MutationObserver(()=>{if(pending&&!errorWrapper.hidden&&errorWrapper.textContent.trim())fail(rtCart('cart_confirm_error'));}).observe(errorWrapper,{subtree:true,attributes:true,childList:true,characterData:true});
  if(!preview&&typeof customElements!=='undefined'){customElements.whenDefined('product-form').then(()=>{bindNativeEvents();render();});window.addEventListener('load',()=>{bindNativeEvents();render();},{once:true});}
  if(compatibility?.value)model.value=compatibility.value;
  showModel();render();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-accessory-rcn1-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('#rcn1-page');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const rt = (key, vars = {}) => (root.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  let localizedKnowledge = {};
  try {
    const parsedKnowledge = JSON.parse(root.querySelector('[data-rh-localized-knowledge]')?.textContent || '{}');
    if (parsedKnowledge && typeof parsedKnowledge === 'object' && !Array.isArray(parsedKnowledge)) localizedKnowledge = parsedKnowledge;
  } catch {}
  const rhCopy = (key, values = {}) => {
    let value = root.getAttribute('data-rh-rt-' + key) || '';
    return value.replace(/%\{([a-z_]+)\}/g, (token, name) => String(values[name] ?? ''));
  };
  const familyLabel = rhCopy('family');
  const controllerName = root.id === 'motion2-page' ? 'DJI RC Motion 2' : root.id === 'motion3-page' ? 'DJI RC Motion 3' : 'DJI RC-N1';
  const formatGoggles = names => new Intl.ListFormat(document.documentElement.lang || 'en', {type: 'disjunction'}).format(names);
  const compatibilityDetail = (item) => {
    const entries = localizedKnowledge.compatibility || [];
    const faqs = localizedKnowledge.faqs || [];
    const detail = i => entries[i]?.details?.value || '';
    if (root.id === 'motion2-page') {
      if (item.status === 'yes') {
        const goggles = {"model-1": ["DJI Goggles 2", "DJI Goggles Integra", "DJI FPV Goggles V2"], "model-2": ["DJI Goggles 2", "DJI Goggles Integra"], "model-3": ["DJI Goggles 2", "DJI Goggles Integra"], "model-4": ["DJI Goggles 2", "DJI Goggles Integra"], "model-5": ["DJI Goggles 2", "DJI Goggles Integra"], "model-6": ["DJI Goggles 2", "DJI Goggles Integra"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? rhCopy('copy_pairing_no', {controller: controllerName}) : rhCopy('copy_ask_models');
    }
    if (root.id === 'motion3-page') {
      if (item.status === 'yes') {
        const goggles = {"model-0": ["DJI Goggles 3", "Goggles N3"], "model-2": ["DJI Goggles 3", "Goggles N3"], "model-4": ["DJI Goggles 3"], "model-5": ["DJI Goggles 3"]};
        return rhCopy('copy_goggles', {goggles: formatGoggles(goggles[item.key] || []), controller: controllerName});
      }
      return item.status === 'no' ? detail(3) : rhCopy('copy_ask_models');
    }
    if (item.key === 'mini4pro') return rhCopy('copy_rcn1_mini4');
    return item.status === 'check' ? rhCopy('copy_ask_exact_model') : rhCopy('copy_rcn1_yes');
  };
  data.compatibility = data.compatibility.map(item => {
    const label = item.label.replace(/ family$/, ' ' + familyLabel);
    let title = item.title;
    if (item.status === 'no') title = item.key === 'mini4pro'
      ? rhCopy('title_rcn1_mini4')
      : rhCopy('title_no', {model: label});
    else if (item.status === 'check') title = root.id === 'rcn1-page'
      ? rhCopy('title_rcn1_check')
      : rhCopy('title_check');
    else title = item.title.replace(/ family$/, ' ' + familyLabel);
    if (item.key === 'other') return {...item, label: rhCopy('other_model'), title, copy: compatibilityDetail(item)};
    return {...item, label, title, copy: compatibilityDetail(item)};
  });
  const form = root.querySelector('#ra-product-form');
  const quantity = form.querySelector('[name="quantity"]');
  const variants = data.variants;
  const currency = data.currency || 'USD';
  let rhCurrencyFormatter;
  const format = (cents) => {
    if (!rhCurrencyFormatter) rhCurrencyFormatter = new Intl.NumberFormat('en-US', {style:'currency', currency});
    return rhCurrencyFormatter.format(cents / 100);
  };
  const us = cents => 'US$' + (cents / 100).toFixed(2);
  const q = sel => root.querySelector(sel);
  const selectedInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
  let variant = variants.find(v => String(v.id) === selectedInput.value) || variants[0];

  function updateOffer(changeUrl = false) {
    const totalUnits = Math.max(1, Math.min(99, Math.floor(Number(quantity.value) || 1)));
    quantity.value = String(totalUnits);
    const subtotal = variant.price * totalUnits;
    const shipping = subtotal >= 9900 ? 0 : 2888;
    q('[data-price]').textContent = format(variant.price);
    q('[data-sticky-price]').textContent = format(subtotal);
    q('[data-sticky-condition]').textContent = variant.title === 'Pristine Pre-owned' ? root.getAttribute('data-rh-condition') : variant.title;
    q('[data-stock]').textContent = variant.available ? document.getElementById("rcn1-page").getAttribute("data-rh-available") : document.getElementById("rcn1-page").getAttribute("data-rh-unavailable");
    const comparison = q('[data-compare-group]');
    comparison.hidden = !(variant.compare_at_price > variant.price);
    if (!comparison.hidden) {
      q('[data-compare]').textContent = format(variant.compare_at_price);
      q('[data-discount]').textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + document.getElementById("rcn1-page").getAttribute("data-rh-discount");
    }
    if (currency === 'USD' && root.dataset.country !== 'UG') {
      q('[data-order-total]').textContent = us(subtotal + shipping);
      q('[data-item-cost]').textContent = us(subtotal);
      q('[data-shipping]').textContent = shipping ? us(shipping) : document.getElementById("rcn1-page").getAttribute("data-rh-free");
      q('[data-sticky-shipping]').textContent = shipping ? document.getElementById("rcn1-page").getAttribute("data-rh-shipping") : document.getElementById("rcn1-page").getAttribute("data-rh-shipping-free");
      q('[data-single-total]').textContent = us(variant.price + (variant.price >= 9900 ? 0 : 2888));
    } else {
      const delivery = window.RHControllerShipping?.fromPage(root, subtotal);
      const singleDelivery = window.RHControllerShipping?.fromPage(root, variant.price);
      const display = value => window.RHControllerShipping.format(root, value, delivery?.approximate);
      q('[data-order-total]').textContent = delivery ? display(delivery.total) : root.getAttribute('data-rh-confirmed');
      q('[data-item-cost]').textContent = format(subtotal);
      q('[data-shipping]').textContent = delivery ? display(delivery.shipping) : root.getAttribute('data-rh-calculated');
      q('[data-sticky-shipping]').textContent = root.getAttribute('data-rh-shipping-checkout');
      q('[data-single-total]').textContent = singleDelivery ? window.RHControllerShipping.format(root, singleDelivery.total, singleDelivery.approximate) : root.getAttribute('data-rh-confirmed');
      const freeFact = q('.ra-delivery-facts > span:first-child');
      if (freeFact) { freeFact.hidden = delivery?.threshold === null; freeFact.style.display = freeFact.hidden ? 'none' : ''; }
      const baseNote = q('[data-base-shipping-note]');
      if (baseNote && delivery?.threshold === null) baseNote.textContent = display(delivery.shipping) + ' · ' + root.getAttribute('data-rh-shipping-checkout');
    }
    root.querySelectorAll('[data-add],[data-sticky-add]').forEach(button => {
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? document.getElementById("rcn1-page").getAttribute("data-rh-add") : document.getElementById("rcn1-page").getAttribute("data-rh-unavailable");
    });
    q('[data-qty="-1"]').disabled = totalUnits === 1;
    q('[data-qty="1"]').disabled = totalUnits === 99;
    if (changeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
  }
  form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', () => {
    variant = variants.find(v => String(v.id) === input.value) || variant;
    updateOffer(true);
  }));
  quantity.addEventListener('change', () => updateOffer());
  quantity.addEventListener('input', () => { if (quantity.value !== '') updateOffer(); });
  root.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
    quantity.value = String((Number(quantity.value) || 1) + Number(button.dataset.qty));
    updateOffer();
  }));
  updateOffer();

  const heroImage = q('[data-hero-image]');
  root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
    const index = Number(button.dataset.photo);
    const item = data.images[index];
    const sized = width => {const url = new URL(item.url);url.searchParams.set('width', width);return url.href;};
    heroImage.srcset = [480,640,960,1200,1600].map(width => `${sized(width)} ${width}w`).join(',');
    heroImage.src = sized(1200);
    q('.ra-photo-wrap').dataset.primary = String(index === 0);
    heroImage.dataset.full = item.url;
    heroImage.alt = item.alt || rhCopy('aria_gallery', {model:'DJI RC-N1',number:String(index+1)});
    q('[data-gallery-count]').textContent = String(index + 1).padStart(2,'0') + ' / ' + String(data.images.length).padStart(2,'0');
    root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const photoDialog = q('[data-photo-dialog]');
  q('[data-zoom]').addEventListener('click', () => {
    photoDialog.querySelector('img').src = heroImage.dataset.full || data.images[0].url;
    photoDialog.showModal();
  });
  const reportImage = q('[data-report-image]');
  const reportTabs = [...root.querySelectorAll('[data-report-tab]')];
  function selectReport(button) {
    reportTabs.forEach(tab => {
      tab.setAttribute('aria-selected', String(tab === button));
      tab.tabIndex = tab === button ? 0 : -1;
    });
    reportImage.src = button.dataset.reportSrc;
    reportImage.alt = button.dataset.reportCaption;
    q('.ra-report-caption [data-report-caption]').textContent = button.dataset.reportCaption;
    q('[data-report-open]').setAttribute('aria-label', rhCopy('aria_enlarge', {caption: button.dataset.reportCaption}));
    q('#ra-report-panel').setAttribute('aria-labelledby', button.id);
  }
  reportTabs.forEach((button, index) => {
    button.addEventListener('click', () => selectReport(button));
    button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % reportTabs.length;
      if (event.key === 'ArrowLeft') next = (index + reportTabs.length - 1) % reportTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = reportTabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      reportTabs[next].focus();
      selectReport(reportTabs[next]);
    });
  });
  q('[data-report-open]').addEventListener('click', () => {
    const enlarged = q('[data-report-enlarged]');
    enlarged.src = reportImage.src;
    enlarged.alt = reportImage.alt;
    q('[data-report-dialog]').showModal();
  });
  const videoDialog = q('[data-video-dialog]');
  const video = videoDialog.querySelector('video');
  root.querySelectorAll('[data-video-open]').forEach(button => button.addEventListener('click', () => {
    videoDialog.showModal();
    video.src = video.dataset.videoSrc;
    video.play().catch(() => { /* Native controls remain available if playback needs another gesture. */ });
  }));
  videoDialog.addEventListener('close', () => {
    video.pause();
    video.removeAttribute('src');
    video.load();
  });
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {if (event.target === dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  });

  const select = q('#ra-drone');
  const result = q('.ra-fit-result');
  select.addEventListener('change', () => {
    const match = data.compatibility.find(item => item.key === select.value);
    if (!match) return;
    result.dataset.fitStatus = match.status;
    q('[data-fit-label]').textContent = match.status === 'yes' ? rhCopy('status_yes') : match.status === 'no' ? rhCopy('status_no') : rhCopy('status_check');
    q('[data-fit-title]').textContent = match.title;
    q('[data-fit-copy]').textContent = match.copy;
    const source = q('[data-fit-source]');
    source.href = match.source;
    source.firstChild.textContent = match.status === 'check' ? rhCopy('ask_team').replace(/\s*↗\s*$/, '') + ' ' : rhCopy('dji_reference') + ' ';
  });
  const sticky = q('.ra-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);}, {threshold:0}).observe(form);
  }
  if (root.dataset.preview === 'true') {
    root.querySelectorAll('[data-preview-checkout]').forEach(button => button.addEventListener('click', () => {
      updateOffer();
      q('[data-demo-summary]').textContent = `Shopify accelerated checkout preview · ${quantity.value} × DJI RC-N1 · ${variant.title} · ${format(variant.price * Number(quantity.value))}. The published page uses Shopify’s native payment button.`;
      q('[data-demo-dialog]').showModal();
    }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      updateOffer();
      q('[data-demo-summary]').textContent = `${quantity.value} × DJI RC-N1 · ${variant.title} · ${format(variant.price * Number(quantity.value))}`;
      q('[data-demo-dialog]').showModal();
    });
  }
})();

(function () {
  'use strict';
  const FREE_AT=9900,STANDARD_SHIPPING=2888;
  const SUPPORTED_MODELS=new Set(['model-0','model-1','model-2','model-3','model-4','model-5','model-6','model-7']);
  function matchesModel(extra,model){return SUPPORTED_MODELS.has(model)&&Array.isArray(extra.models)&&extra.models.includes(model);}
  function selectedExtras(extras,selections,model){
    const seen=new Set();
    return selections.map(({handle,variantId})=>{
      if(seen.has(handle))throw Error(rtCart('extra_duplicate'));seen.add(handle);
      const extra=extras.find(e=>e.handle===handle);
      if(!extra||!matchesModel(extra,model))throw Error(rtCart('extra_mismatch'));
      if(!variantId)throw Error(rtCart('extra_choose_option',{item:extra.title}));
      const v=extra.variants.find(v=>String(v.id)===String(variantId));
      if(!v?.available)throw Error(rtCart('extra_unavailable',{item:extra.title}));
      return {id:v.id,price:v.price,title:extra.title,handle:extra.handle};
    });
  }
  function estimate({cartTotal,mainPrice,mainQuantity,extrasTotal,currency,cartCurrency}){
    for(const n of [cartTotal,mainPrice,mainQuantity,extrasTotal])if(!Number.isSafeInteger(n)||n<0)throw Error(rtCart('invalid_amount'));
    if(mainQuantity<1)throw Error(rtCart('invalid_quantity'));
    const itemsSubtotal=cartTotal+mainPrice*mainQuantity+extrasTotal;
    const supportedCurrency=typeof currency==='string'&&currency.length>0&&cartCurrency===currency;
    const supportedUSD=supportedCurrency&&currency==='USD';
    const shipping=supportedUSD?(itemsSubtotal>=FREE_AT?0:STANDARD_SHIPPING):null;
    return {itemsSubtotal,supportedCurrency,supportedUSD,remaining:supportedUSD?Math.max(0,FREE_AT-itemsSubtotal):null,shipping,total:supportedUSD?itemsSubtotal+shipping:null};
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={matchesModel,selectedExtras,estimate};
  if(typeof document==='undefined')return;
  const page=document.querySelector('#rcn1-page'),json=page?.querySelector('[data-product-json]');
  if(!json)return;
  let product;try{product=JSON.parse(json.textContent);}catch{return;}
  const rtCart = (key, vars = {}) => (page.getAttribute('data-rh-dyn-' + key) || '').replace(/%\{([a-z_]+)\}/g, (match, name) => String(vars[name] ?? ''));
  const find=s=>page.querySelector(s),dialog=find('[data-extras-dialog]'),open=find('[data-extra-open]');
  const model=find('[data-extra-model]'),list=find('[data-extra-list]'),empty=find('[data-extra-empty]'),status=find('[data-extra-status]');
  const nativeForm=find('[data-extra-native-form]'),form=find('#ra-extra-set-form'),submit=find('[data-extra-submit]');
  const mainIdInput=find('[data-extra-main-id]'),mainQuantityInput=find('[data-extra-main-quantity]'),compatibility=find('#ra-drone');
  if(!dialog||!open||!model||!list||!nativeForm||!form||!submit||!mainIdInput||!mainQuantityInput)return;
  const preview=page.dataset.preview==='true',currency=product.currency,extras=product.extras||[];
  const groups=[...list.querySelectorAll('[data-extras-group]')];
  const errorWrapper=nativeForm.querySelector('.product-form__error-message-wrapper');
  let cart=product.cart,cartLoading=false,pending=false,blocked=false,blockMessage='',previewMessage='',uncertaintyTimer;
  let cartUpdateEvent=null,cartEventsBound=false;
  let rhExtrasCurrencyFormatter;
  const money=n=>{
    if(currency==='USD')return 'US$'+(n/100).toFixed(2);
    if(!rhExtrasCurrencyFormatter)rhExtrasCurrencyFormatter=new Intl.NumberFormat('en-US',{style:'currency',currency});
    return rhExtrasCurrencyFormatter.format(n/100);
  };
  const put=(s,v)=>{const e=find(s);if(e)e.textContent=v;};
  const validCart=()=>cart&&Number.isSafeInteger(cart.total_price)&&cart.total_price>=0&&typeof cart.currency==='string';
  function currentMain(){const selected=find('#ra-product-form input[name=id]:checked');return {variant:product.variants.find(v=>String(v.id)===String(selected?.value)),quantity:Number(find('#ra-product-form input[name=quantity]')?.value)};}
  function selectedCards(){return [...list.querySelectorAll("product-info-upsell[data-selected='true']")].map(e=>({handle:e.dataset.handle,variantId:e.dataset.id}));}
  function clearSelections(){for(const card of list.querySelectorAll('product-info-upsell')){card.dataset.selected='false';const toggle=card.querySelector('.upsell-toggle-btn');if(toggle?.hasAttribute('aria-pressed'))toggle.setAttribute('aria-pressed','false');}previewMessage='';}
  function showModel(){
    let shown=0;
    for(const group of groups){group.hidden=!SUPPORTED_MODELS.has(model.value)||group.dataset.modelKey!==model.value;if(!group.hidden)shown+=group.querySelectorAll('product-info-upsell').length;}
    empty.hidden=shown>0;
    empty.textContent=!model.value?document.getElementById("rcn1-page").getAttribute("data-rh-choose-drone"):!SUPPORTED_MODELS.has(model.value)?rtCart('model_unconfirmed',{model:'RC-N1'}):rtCart('empty_extras');
  }
  function changeModel(value,notify){model.value=value;clearSelections();showModel();render();if(notify&&compatibility&&compatibility.value!==value&&[...compatibility.options].some(o=>o.value===value)){compatibility.value=value;compatibility.dispatchEvent(new Event('change',{bubbles:true}));}}
  function fail(message){blocked=true;pending=false;clearTimeout(uncertaintyTimer);blockMessage=message;render();}
  function render(){
    const {variant:main,quantity}=currentMain();
    const mainValid=!!main?.available&&Number.isSafeInteger(quantity)&&quantity>0;
    mainIdInput.value=mainValid?main.id:'';mainQuantityInput.value=mainValid?quantity:'';
    let chosen=[],selectionError='';try{chosen=selectedExtras(extras,selectedCards(),model.value);}catch(e){selectionError=e.message;}
    const currencyMatches=validCart()&&cart.currency===currency&&page.dataset.currency===currency;
    const canEstimate=mainValid&&currencyMatches&&!selectionError;
    const result=canEstimate?estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,e)=>s+e.price,0),currency,cartCurrency:cart.currency}):null;
    const marketDelivery = result ? window.RHControllerShipping?.fromPage(page, result.itemsSubtotal) : null;
    const useMarket = currency !== 'USD' || page.dataset.country === 'UG';
    const delivery = useMarket ? marketDelivery : result?.supportedUSD ? {...result, threshold:FREE_AT, approximate:false} : null;
    const deliveryMoney = value => window.RHControllerShipping.format(page, value, delivery?.approximate);
    const goal = delivery || window.RHControllerShipping?.fromPage(page, 0);
    const thresholdAmount = find('[data-rh-threshold-amount]');
    if (thresholdAmount && goal?.threshold != null) thresholdAmount.firstChild.nodeValue = window.RHControllerShipping.format(page, goal.threshold, goal.approximate);
    const freeBenefit = find('[data-rh-free-benefit]');
    if (freeBenefit) freeBenefit.hidden = !!goal && goal.threshold === null;
    const freeProgress = find('.ra-extra-threshold');
    if (freeProgress) freeProgress.style.display = goal?.threshold === null ? 'none' : '';
    for(const card of list.querySelectorAll('product-info-upsell')){const toggle=card.querySelector('.upsell-toggle-btn'),extra=extras.find(x=>x.handle===card.dataset.handle);if(toggle&&extra){toggle.setAttribute('aria-pressed',String(card.dataset.selected==='true'));toggle.setAttribute('aria-label',card.dataset.selected==='true'?rtCart('remove_extra',{item:extra.title}):rtCart('select_extra',{item:extra.title}));}}
    put('[data-extra-current-cart]',validCart()?money(cart.total_price):document.getElementById("rcn1-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-main-label]',mainValid?'RC-N1 × '+quantity:'RC-N1 '+page.getAttribute('data-rh-unavailable'));
    put('[data-extra-main-amount]',mainValid?money(main.price*quantity):document.getElementById("rcn1-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-subtotal]',result?money(result.itemsSubtotal):document.getElementById("rcn1-page").getAttribute("data-rh-unavailable"));
    put('[data-extra-shipping]',delivery ? (delivery.shipping===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.shipping)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-total]',delivery ? deliveryMoney(delivery.total) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-remaining]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?rtCart('threshold_reached'):rtCart('extra_remaining',{amount:deliveryMoney(delivery.remaining)})) : page.getAttribute('data-rh-shipping-checkout'));
    const progress=find('[data-extra-progress]');progress.hidden=delivery?.threshold==null;if(delivery?.threshold!=null){progress.max=delivery.threshold;progress.value=Math.min(result.itemsSubtotal,delivery.threshold);}else progress.removeAttribute('value');
    put('[data-extra-gap]',delivery?.remaining!=null ? (delivery.remaining===0&&!delivery.approximate?page.getAttribute('data-rh-free'):deliveryMoney(delivery.remaining)) : page.getAttribute('data-rh-calculated'));
    put('[data-extra-gap-label]',delivery?.remaining!=null ? (delivery.remaining===0?rtCart('standard_fee_selection'):page.getAttribute('data-rh-shipping-goal')) : page.getAttribute('data-rh-shipping-checkout'));
    const context=chosen.length?rtCart('planned_set'):rtCart('with_model',{model:'RC-N1'});put('[data-extra-context]',cart?.item_count?rtCart('existing_cart_context',{context}):context);
    put('[data-extra-shipping-promise]',delivery?.threshold===null ? deliveryMoney(delivery.shipping)+' · '+page.getAttribute('data-rh-shipping-checkout') : result?.supportedUSD?(result.remaining===0?rtCart('free_shipping_reached'):page.getAttribute('data-rh-shipping-policy')):rtCart('base_policy'));
    const nativeReady=preview||(typeof customElements!=='undefined'&&!!customElements.get('product-form')&&cartEventsBound);
    submit.disabled=pending||blocked||cartLoading||!nativeReady||!canEstimate||!result?.supportedCurrency||!chosen.length;
    list.inert=pending;
    status.textContent=blocked?blockMessage:cartLoading?rtCart('cart_updating'):pending?rtCart('cart_adding'):previewMessage||selectionError||(!currencyMatches?rtCart('currency_unavailable'):!mainValid?rtCart('need_controller_quantity'):!chosen.length?rtCart('nothing_extra'):!nativeReady?rtCart('cart_loading'):'');
    find('[data-extra-cart-link]').href=product.routes.cart;
  }
  compatibility?.addEventListener('change',()=>{if(model.value!==compatibility.value)changeModel(compatibility.value,false);});
  model.addEventListener('change',()=>changeModel(model.value,true));
  page.addEventListener('change',e=>{if(e.target.matches('#ra-product-form input[name=id]'))render();});
  page.addEventListener('input',e=>{if(e.target.matches('#ra-product-form input[name=quantity]'))render();});
  page.addEventListener('click',e=>{if(e.target instanceof Element&&e.target.closest('#ra-product-form [data-qty]'))queueMicrotask(render);});
  dialog.addEventListener('close',()=>{if(!pending){clearSelections();render();}});
  new MutationObserver(render).observe(list,{subtree:true,attributes:true,attributeFilter:['data-selected','data-id']});
  if(preview)list.addEventListener('click',e=>{const toggle=e.target.closest('.upsell-toggle-btn'),card=toggle?.closest('product-info-upsell');if(!card)return;e.preventDefault();card.dataset.selected=card.dataset.selected==='true'?'false':'true';toggle.setAttribute('aria-pressed',card.dataset.selected);});
  open.addEventListener('click',async()=>{
    if(!dialog.open)dialog.showModal();
    if(preview||blocked){render();return;}
    cartLoading=true;render();
    try{const r=await fetch(product.routes.cart.replace(/\/$/,'')+'.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('Cart read failed');const fresh=await r.json();if(!Number.isSafeInteger(fresh.total_price)||fresh.total_price<0||typeof fresh.currency!=='string')throw Error('Invalid cart');cart=fresh;}
    catch{cart=null;fail(rtCart('cart_read_error'));}
    finally{cartLoading=false;render();}
  });
  dialog.addEventListener('submit',e=>{
    if(e.target!==form)return;
    const {variant:main,quantity}=currentMain();let chosen=[],offer=null;
    try{chosen=selectedExtras(extras,selectedCards(),model.value);if(main?.available&&Number.isSafeInteger(quantity)&&quantity>0&&validCart())offer=estimate({cartTotal:cart.total_price,mainPrice:main.price,mainQuantity:quantity,extrasTotal:chosen.reduce((s,x)=>s+x.price,0),currency,cartCurrency:cart.currency});}catch{chosen=[];}
    const valid=!blocked&&!pending&&!cartLoading&&offer?.supportedCurrency&&page.dataset.currency===currency&&chosen.length>0;
    if(!valid||preview){e.preventDefault();e.stopImmediatePropagation();if(preview&&valid)previewMessage='Preview only: RC-N1 × '+quantity+' + '+chosen.length+' selected extra'+(chosen.length>1?'s':'')+'. Items '+money(offer.itemsSubtotal)+ (offer.supportedUSD?'; standard shipping '+money(offer.shipping)+'; estimated total '+money(offer.total):'; shipping and final total calculated at checkout')+'. No store cart changes.';render();return;}
    if(typeof subscribe!=='function'||!cartUpdateEvent||!customElements.get('product-form')){e.preventDefault();e.stopImmediatePropagation();fail(rtCart('cart_form_unavailable'));return;}
    pending=true;uncertaintyTimer=setTimeout(()=>{if(pending)fail(rtCart('cart_uncertain'));},30000);render();
  },true);
  function bindNativeEvents(){
    if(preview||cartEventsBound||typeof subscribe!=='function'||typeof PUB_SUB_EVENTS==='undefined'||!PUB_SUB_EVENTS.cartUpdate)return;
    cartUpdateEvent=PUB_SUB_EVENTS.cartUpdate;
    subscribe(cartUpdateEvent,event=>{if(!pending||event?.source!=='product-form'||String(event.productVariantId)!==mainIdInput.id)return;pending=false;clearTimeout(uncertaintyTimer);dialog.close();window.location.assign(product.routes.cart);});
    cartEventsBound=true;
  }
  bindNativeEvents();
  if(errorWrapper)new MutationObserver(()=>{if(pending&&!errorWrapper.hidden&&errorWrapper.textContent.trim())fail(rtCart('cart_confirm_error'));}).observe(errorWrapper,{subtree:true,attributes:true,childList:true,characterData:true});
  if(!preview&&typeof customElements!=='undefined'){customElements.whenDefined('product-form').then(()=>{bindNativeEvents();render();});window.addEventListener('load',()=>{bindNativeEvents();render();},{once:true});}
  if(compatibility?.value)model.value=compatibility.value;
  showModel();render();
})();


  } catch(e) { console.error(e); }
})();
})();
